// src/services/profileApi.js
import axios from './axiosInstance';

const BASE_URL = `${process.env.REACT_APP_API_URL}/api`;

// Ottieni i dati del profilo utente corrente
export const getProfile = async () => {
    const token = localStorage.getItem('token');
    const res = await axios.get(`${BASE_URL}/profile`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    return res.data;
};

// Aggiorna i dati del profilo
export const updateProfile = async (profileData) => {
    const token = localStorage.getItem('token');
    const res = await axios.put(`${BASE_URL}/profile`, profileData, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    return res.data;
};

// Cambio password
export const changePassword = async (currentPassword, newPassword) => {
    const token = localStorage.getItem('token');
    const res = await axios.put(
        `${BASE_URL}/profile/password`,
        { currentPassword, newPassword },
        {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return res.data;
};